import { render, staticRenderFns } from "./RoomInfoCard.vue?vue&type=template&id=4353a994&scoped=true&"
import script from "./RoomInfoCard.vue?vue&type=script&lang=ts&"
export * from "./RoomInfoCard.vue?vue&type=script&lang=ts&"
import style0 from "./RoomInfoCard.vue?vue&type=style&index=0&id=4353a994&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4353a994",
  null
  
)

export default component.exports